import { render, staticRenderFns } from "./ChangeOrder.vue?vue&type=template&id=152c678b&"
import script from "./ChangeOrder.vue?vue&type=script&lang=js&"
export * from "./ChangeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports